import Amplify, { API, graphqlOperation } from 'aws-amplify';
import { createPedigree, updatePedigree, deletePedigree } from '../graphql/mutations';
import { pedigreeByDate, getPedigree, listPedigrees, searchPedigrees, searchTransaction } from '../graphql/queries';
import {Pedigree} from '../data/pedigree';

let autocompleteQueue = null;
let autocompleteReady = true;

export const fetchPedigreeAction = async (id, state, dispatch) => {
    try {
        const pedigree = await API.graphql(graphqlOperation(getPedigree, {id:id})); 
        let pedigreeData = pedigree.data.getPedigree;
        loadRemoteData(pedigreeData, state, dispatch);
    } catch(err) {
        console.log('fetchPedigreeAction failed');
    }
};

export const selectsection = async (sectionList, state, dispatch) => {
    let obj = JSON.parse(JSON.stringify(state));
    sectionList.forEach((input) => {
        let keys = `${input.name}`;

        let pointer = keys.split('.').reduce((o,i)=>{
            return (Array.isArray(o)) ? o[parseInt(i)] : o[i];
        }, obj);
        
        let newValue = input.autoValue || '';
        if (!input.hasOwnProperty('lock')) {
            pointer.value = newValue;
        } else {
            pointer.value = '';
        }
    });

    return dispatch({
        type: 'UPDATE_LOCAL_DATA',
        payload: {Pedigree: obj.Pedigree}
    });
};

// Util used to update database
export const walkDataAction = async (state, dispatch) => {
    let itemCount = 0;
    let limit = 50;
    let nextToken = '';
    
    try {
        getPedigreesLoop({limit});
    } catch(err) {
        console.log('List call failed', err);
    }
    
    async function getPedigreesLoop(data) {
        // console.log('this is the data', data);
        const pedigree = await API.graphql(graphqlOperation(listPedigrees, data));
        const pedigreeData = pedigree.data.listPedigrees.items;
        
        nextToken = pedigree.data.listPedigrees.nextToken || '';
        itemCount += pedigreeData.length;
        
        let newData = pedigreeData.map(async (item) => {
            const date      = new Date(item.createdAt);
            const unixTime  = Math.floor(date.getTime() / 1000);
            const sixYears  = 31556926 * 6;
            const expiresAt = unixTime + sixYears;
            
            // console.log('time', unixTime, new Date((unixTime * 1000)));
            // console.log('exp', expiresAt, new Date((expiresAt * 1000)));
            
            // if (item.ClientId === "TestCID") {
                // item.ExpiresAt = expiresAt;
                
                // try {
                //     let updateCall = await API.graphql(graphqlOperation(updatePedigree, {input: item})),
                //     updatedPedigree = updateCall.data.updatePedigree;
                //     console.log('Updated Pedigree', updatedPedigree);
                // } catch(err) {
                //     console.log('Failed to update with dates', err);
                // }
                // console.log('found clientId', item);
            // }
            return item;
        });
        
        console.log('walk data', pedigreeData.length, itemCount, newData);
        if (nextToken !== '') getPedigreesLoop({limit, nextToken});
        
        return pedigree;
    }
    return {};
};

export const fetchDataAction = async (data, state, dispatch) => {
    
    if (data.nextToken === '') delete data.nextToken;
    if (data.hasOwnProperty('nextType')) delete data.nextType;
    
    const pedigree = await API.graphql(graphqlOperation(pedigreeByDate, {...data, 'PedType': state.PedType, 'sortDirection': 'DESC'}));
    
    const pedigreeDate = pedigree.data.pedigreeByDate.items;
    
    const Next = {
        ...data,
        nextToken: pedigree.data.pedigreeByDate.nextToken || '',
        nextType: 'AS'
    };
    
    const payload  = {...state, PedigreeList: pedigreeDate, Next};

    return dispatch({
      type: 'FETCH_DATA',
      payload
    });
};

export const clearLocalData = (state, dispatch) => {
    return dispatch({
        type: 'CLEAR_LOCAL_DATA',
        payload: {}
    });
};

export const updateLocalView = (path, state, dispatch) => {
    return dispatch({
        type: 'UPDATE_LOCAL_DATA',
        payload: path
    });
};

export const updateLocalData = (path, state, dispatch) => {
    return dispatch({
        type: 'UPDATE_LOCAL_DATA',
        payload: createPayload(path, state)
    });
};

export const loadTemplate = (state, dispatch) => {
    if (state.Template.match) {
        let pedigree = state.Autocomplete[state.Template.matchRef];
        
        pedigree.ClientId = state.Pedigree.ClientId.value;
        pedigree.GroupID = state.Pedigree.GroupID.value;
        pedigree.Invoice = state.Pedigree.Invoice.value;
        pedigree.IssuedTo = state.Pedigree.IssuedTo.value;
        pedigree.PedType = state.Pedigree.PedType.value;
        pedigree.Published = state.Pedigree.Published.value;
        pedigree.createdAt = state.Pedigree.createdAt.value;
        pedigree.id = state.Pedigree.id.value;
        pedigree.updatedAt = state.Pedigree.updatedAt.value;
        
        pedigree.PurchaseDate = pedigree.TransactionDate;
        pedigree.TransactionDate = state.Pedigree.TransactionDate.value;
        
        state.Autocomplete = [];
        state.Template.ItemId = {value: '', auto: []};
        state.Template.LotId = {value: '', auto: []};
        state.Template.matchRef = null;
        state.Template.match = false;
        
        loadRemoteData(pedigree, state, dispatch);
    }

    return dispatch({
        type: 'UPDATE_LOCAL_DATA',
        payload: {}
    });
};

export const updateLocalList = async (data, state, dispatch) => {
    const pedigreeListCopy = JSON.parse(JSON.stringify(state.PedigreeList));
    const newPedigree = pedigreeListCopy.find(p => (p.id === data.pedigree.id));
    
    newPedigree.Published = data.value;
    newPedigree.GroupID = data.group;
    
    const pedigree = JSON.parse(JSON.stringify(newPedigree));
    
    try {
        let call = await API.graphql(graphqlOperation(updatePedigree, {input: pedigree}));
        let updated = call.data.updatePedigree;
 
        const newPedigreeList = state.PedigreeList.map((pedigree) => {
            return (pedigree.id === updated.id) ? updated : pedigree;
        });
   
        let mergedData = mergeData(pedigree, state, dispatch);

        return dispatch({
            type: 'LOAD_REMOTE_DATA',
            payload: {Pedigree:{...mergedData}, PedigreeList: pedigreeListCopy}
        });
    } catch(err) {
        console.log('err', err);
    }
};

export const elasticSearch = async (data, state, dispatch) => {
    let matchPhrase = data.search.map((field) => {
        return {match: {[buildSearchPath(field.key)]: field.value}};
    });
        
    const match = {match:{PedType: data.pedType}};
    const query = {bool: {must: [match, ...matchPhrase]}};
    const sort  = [{updatedAt : {order : "DESC"}}];
    
    let queryObj = {
        filter: JSON.stringify(query),
        sort: JSON.stringify(sort),
        limit: data.limit
    };
    let searchCall = await API.graphql(graphqlOperation(searchTransaction, queryObj ));
        
    return searchCall;
};

export const refreshAutoComplete = async (data, state, dispatch) => {
    const limitSearch = 20;
    // TODO remove updateLocalData() dependency
    let localUpdate = await updateLocalData(data.path, state, dispatch);
    data.pedType = state.PedType;
    data.limit = limitSearch;
    let keys = [];

    if (autocompleteReady) {
        autocompleteReady = false;
        let payload = await search(data, searchHandler, state, dispatch);
    } else {
        autocompleteQueue = data;
    }
    
    function searchHandler(searchData) {
        if (data.search.length === 0) {
            fetchDataAction({limit: limitSearch, nextToken: ''}, state, dispatch);
        } else {
        if (searchData.data.length !== 0) traverse(state.Pedigree, searchData.data, keys);
        }
        return dispatch({
            type: 'UPDATE_SEARCH_DATA',
            payload : {Next: searchData.next}
        });
    }
};

export const templateSearch = async (data, state, dispatch) => {
    const limitSearch = 10;
    data.pedType = 'TEMP';
    data.limit = limitSearch;
    if (autocompleteReady) {
        autocompleteReady = false;
        let payload = await search(data, searchHandler, state, dispatch);
    } else {
        autocompleteQueue = data;
    }
    
    function searchHandler(searchData) {

        let TempData = { ItemId: {value: data.path.ItemId, auto: []}, LotId: {value: data.path.LotId, auto: []} };
        let searchArr = searchData.data.reduce((temp, ped, i) => {
            
            if (!temp.ItemId.auto.includes(ped.Transaction.ItemId)
                && ped.Transaction.ItemId !== '') {
                temp.ItemId.auto.push(ped.Transaction.ItemId);
            }
            if (!temp.LotId.auto.includes(ped.Transaction.LotId)
                && ped.Transaction.LotId !== '') {
                temp.LotId.auto.push(ped.Transaction.LotId);
            }
            return temp;
        },TempData);

        let pedigreeMatch = searchData.data.findIndex((ped) => {
            return (
                    searchArr.ItemId.value === ped.Transaction.ItemId
                    && ped.Transaction.ItemId !== ''
                    && searchArr.LotId.value === ped.Transaction.LotId
                    && ped.Transaction.LotId !== ''
                );
        });
        
        let Template = {
            ...searchArr,
            matchRef: pedigreeMatch,
            match: (pedigreeMatch !== -1)
        };

        let payload = {
            Next: searchData.next,
            Autocomplete: searchData.data,
            Template
        };
 
        return dispatch({
            type: 'UPDATE_SEARCH_DATA',
            payload
        });
    }
};

export const searchPedigreeFields = async (data, state, dispatch) => {
    const limitSearch = 20;

    if (data.next === '') {
        data.pedType = state.PedType;
        data.limit = limitSearch;
    }

    if (autocompleteReady) {
        autocompleteReady = false;
        let payload = await search(data, searchHandler, state, dispatch);
    } else {
        autocompleteQueue = data;
    }
    function searchHandler(searchData) {
        if (searchData.length === 0) {
            fetchDataAction({limit: limitSearch, nextToken: ''}, state, dispatch);
        } else {
            let payload = {PedigreeList: searchData.data, Next: searchData.next};
            dispatch({
                type: 'UPDATE_SEARCH_DATA',
                payload
            });
        }
        
    }
};

function search(data, handleTask, state, dispatch) {
    if (data.next === '') {
        let matchPhrase = data.search.map((field) => {
            return {match_phrase_prefix: {[buildSearchPath(field.key)]: field.value}};
        });
     
        let match = [];
        if (state.User === 'USER') {
            match =  [{match:{PedType:data.pedType}}, {match:{ClientId:state.Group}}];
        } else {
            match =  [{match:{PedType:data.pedType}}];
        }

        data.query = {bool: {must:[...match, ...matchPhrase]}};
        data.sort = [{updatedAt : {order : "DESC"}}];
    }
    return new Promise(async(resolve, reject) => {
        try {
            let searchData = await processSearch(data);
            handleTask(searchData);
                
            if (autocompleteQueue !== null) {
                let queued = JSON.parse(JSON.stringify(autocompleteQueue));
                autocompleteQueue = null;
                search(queued, handleTask, state, dispatch);
            } 
            autocompleteReady = true;
            resolve();
        } catch(err) {
            reject(err);
            console.log('err', err);
        }
    });
}

function processSearch(data) {
    return new Promise(async (resolve, reject) => {
        try {
            let queryObj = {
                filter: JSON.stringify(data.query),
                sort: JSON.stringify(data.sort),
                limit: data.limit
            };

            if (data.next !== '') queryObj.nextToken = data.next;
            let searchCall = await API.graphql(graphqlOperation(searchTransaction, queryObj ));

            data.nextType = 'ES';
            data.next = (searchCall.data.searchTransaction && searchCall.data.searchTransaction.hasOwnProperty('nextToken'))
                 ? searchCall.data.searchTransaction.nextToken
                 : '';
                 
            let searchData = {
                next: data,
                data: searchCall.data.searchTransaction.items
            };
            
            resolve(searchData);
        } catch(err) {
            console.log('ES querry error', err);
            reject(err);
        }
    });
}

// generate autocomplete data
function traverse(o, searchData, keys) {
    let isArray = Array.isArray(o);
    // check if "o" is an array or object to iterate over
    let list = (isArray) ? o : Object.keys(o);
    // loop over object/array
    list.forEach((val, i) => {
        let value = (isArray) ? val : o[val];
        let index = (isArray) ? i : val;
        // check if value is an object and not {value:"", auto:[]} data object 
        if (value !== null && typeof(value)=="object" && !value.hasOwnProperty('auto')) {
            // push accessor key into keys
            keys.push(index);
            // send array/object to be walked
            traverse(value, searchData, keys);
        } else {
            
            let itemValues = lookUpValue(keys, searchData);
            
            o[val].auto = [...new Set(itemValues)];
        }

        // generate autocomplete array for dropdown
        function lookUpValue(keys, searchData) {
            let keyCopy = [...keys];
            keyCopy.push(val);

            return searchData.reduce((acc, obj, i, arr) => {
                let newValue = keyCopy.reduce((o,i)=>{
                    let x =   (Array.isArray(o)) ? o[parseInt(i)] : o[i];

                    return x || [];
                }, obj);
                if (newValue !== undefined && newValue !== "" ) acc.push(newValue);

                return acc;
            },[]);
        }
    });
    keys.pop();
    return o;
}

function buildSearchPath(key) {
    let keys = key.split('.').filter((key) => {
        return isNaN(key);
    });
    
    if (keys[0] === 'Pedigree') keys.shift();
    return keys = keys.join('.');
}

export const loadRemoteData = (pedigree, state, dispatch) => {
    let o = JSON.parse(JSON.stringify(pedigree));
    let data = mergeData(o, state, dispatch);
    
    dispatch({
        type: 'LOAD_REMOTE_DATA',
        payload: {Pedigree:{...data}, PedType: pedigree.PedType}
    });
    
    return {};
};

export const deleteRemoteData = async (id, state, dispatch) => {
    try {
        let call = await API.graphql(graphqlOperation(deletePedigree, { input: {id} }));
        
        let pedigreeList = [...state.PedigreeList].filter((pedigree) => {
            return pedigree.id !== id;
        });

        return dispatch({
            type: 'DELETE_REMOTE_DATA',
            payload: {PedigreeList: pedigreeList}
        });
    } catch(err) {
        console.log('err', err);
    }
};

export const createRemoteData = async (pedType, state, dispatch) => {
    let pedigreeList = [...state.PedigreeList];
    let pedigreeData = JSON.parse(JSON.stringify(Pedigree)); 

    delete pedigreeData.id;
   
    const newDate = new Date();
    const [month, day, year] = newDate.toLocaleDateString().split('/');
    
    const unixTime = Math.floor(Date.now() / 1000);
    const sixYears = 31556926 * 6;
    const expiresAt = unixTime + sixYears;

    pedigreeData.PedType.value = pedType;
    pedigreeData.Published.value = 'NEW';

    let data = cleanData(pedigreeData);

    try {
        let createCall = await API.graphql(graphqlOperation(createPedigree, {input: data})),
            createdPedigree = createCall.data.createPedigree;

        createdPedigree.TransactionDate = `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
        createdPedigree.createdAt = newDate.toISOString();
        createdPedigree.ExpiresAt = expiresAt;
            
        let updateCall = await API.graphql(graphqlOperation(updatePedigree, {input: createdPedigree})),
            updatedPedigree = updateCall.data.updatePedigree;

        pedigreeList.unshift(updatedPedigree);

        return dispatch({
            type: 'CREATE_REMOTE_DATA',
            payload: {PedigreeList: pedigreeList}
        });
    } catch(err) {
        console.log('err', err);
    }
};

export const cloneRemoteData = async (state, dispatch) => {
    let pedigreeList = [...state.PedigreeList];
    let pedigreeData = JSON.parse(JSON.stringify(Pedigree));
    
    delete pedigreeData.id;
    pedigreeData.IssuedTo = state.Pedigree.IssuedTo;
    pedigreeData.ClientId = state.Pedigree.ClientId;
    pedigreeData.Invoice = state.Pedigree.Invoice;
    pedigreeData.TransactionDate = state.Pedigree.TransactionDate;
    pedigreeData.Published.value = 'NEW';
    
    let data = cleanData(pedigreeData);

    try {
        let call = await API.graphql(graphqlOperation(createPedigree, {input: data})),
            createdPedigree = call.data.createPedigree;

        pedigreeList.unshift(createdPedigree);
        
        let o = JSON.parse(JSON.stringify(createdPedigree));
        let mergedData = mergeData(o, state, dispatch);

        dispatch({
            type: 'UPDATE_REMOTE_DATA',
            payload: {PedigreeList: pedigreeList, Pedigree:{...mergedData}}
        });
        
        return createdPedigree;
    } catch(err) {
        console.log('err', err);
    }
};

export const updateRemoteData = async (state, dispatch) => {
    let pedigreeData = JSON.parse(JSON.stringify(state.Pedigree));
    let data = cleanData(pedigreeData);
    
    if (data.Published === 'NEW') data.Published = 'DRAFT';

    try {
        let call = await API.graphql(graphqlOperation(updatePedigree, {input: data}));
        let updated = call.data.updatePedigree;
     
        const newPedigreeList = state.PedigreeList.map((pedigree) => {
            return (pedigree.id === updated.id) ? updated : pedigree;
        });

        return dispatch({
            type: 'LOAD_REMOTE_DATA',
            payload: {PedigreeList: newPedigreeList}
        });
    } catch(err) {
        console.log('err', err);
    }
};

// merge autocomplet data
function mergeData(o) {
    let list = (Array.isArray(o)) ? o : Object.keys(o);

    list.forEach((val, i) => {

        let value = (Array.isArray(o)) ? val : o[val];
        if (value !== null && typeof(value)=="object") {
            mergeData(value);
        } else {
            let dataObj = {value:o[val], auto:[]};
            o[val] = dataObj;
        }
    });
    return o;
}

// remove auto complet data before storing in database
function cleanData(o) {
    let list = (Array.isArray(o)) ? o : Object.keys(o);
    list.forEach((val, i) => {

        let value = (Array.isArray(o)) ? val : o[val];
        if (value !== null && typeof(value)=="object" && !value.hasOwnProperty('auto')) {
            cleanData(value);
        } else {
            let tempVal = o[val].value;
            o[val] = tempVal;
        }
    });
    return o;
}

function createPayload(path, state) {
    const {key, value} = path;
    const ref = key.split('.').reduce((o,i)=>{
        return (Array.isArray(o)) ? o[parseInt(i)] : o[i];
    }, state);
    ref.value = value;
    
    return state;
}
